const pagetoTop = () => {
  let backToTop = $('#back-top');
  backToTop.on('click', function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
}

export { pagetoTop };
